<template>
    <el-card class="box-card">
        <div class="component-content">
            <el-card>
                <div slot="header" class="clearfix">
                    <span>剧本数据</span>
                </div>
                <el-form>
                    <el-form-item>
                        <el-button type="primary" @click="generateData()" v-clipboard:copy="drama" v-clipboard:success="onCopy"
                            v-clipboard:error="onError">生成数据</el-button>
                        <el-button type="warning" @click="parseData()">解析数据</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="dramaConfigSelectVal" clearable @change="getDramaConfigSelectVal">
                            <el-option v-for="item in dramaConfigData" :key="item.id" :label="item.id + '-' + item.dialog_desc + '(模板:' +item.template_id + ')'" :value="item.id + '-' +item.template_id + '-' + item.dialog_json">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div>1.请输入id（数据库id）</div>
                        <div>2.请输入模板id (0为大世界模板,其他数值参考ActivityTemplateConfig的Id)</div>
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="请输入id" v-model="dramaId" :disabled="isModifyDramaId" style="width: 170px"></el-input>
                        <el-input placeholder="请输入模板id" v-model="templateId" :disabled="isModifyDramaId" style="width: 170px"></el-input>
                        <el-button type="primary" @click="uploadRandomEventLang">固化</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-input type="textarea" v-model="drama"></el-input>
                    </el-form-item>
                </el-form>

            </el-card>
            <el-card>

                <div slot="header" class="clearfix">
                    <span>详细数据</span>
                </div>
                <el-form label-suffix=":">
                    <el-form-item label="剧本操作">
                        <el-button @click="onAddDialog" type="success">新建对话</el-button>
                        <el-button @click="simulateNodeShow" type="primary">模拟对话</el-button>
                        <el-button v-if="showDetailTable == false" @click="showDetailTable = true">展开详情</el-button>
                        <el-button v-if="showDetailTable == true" @click="showDetailTable = false">收起详情</el-button>
                    </el-form-item>
                    <el-form-item label="固定跳出点">
                        <el-row>
                            <el-col :span="3" v-for="(node,nodeIdx) in nodes" v-if="node.dialogData.id > 0 && node.dialogData.id <= 6"
                                :key="nodeIdx">
                                {{node.id + '-' + node.name}}
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
                <el-table :data="nodes.slice(6)" border style="width: 100%" v-if="showDetailTable" @row-click="updateMethod">
                    <el-table-column prop="dialogData.id" label="编号" width="120"></el-table-column>
                    <el-table-column label="内容" width="800" v-slot="scope">
                        <span>{{scope.row.name.slice(0,50) + (scope.row.name.length > 50?"...":"")}}</span>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="updateMethod(scope.row)" v-if="scope.row.dialogData.id == 0 || scope.row.dialogData.id > 6">修改
                            </el-button>
                            <el-button type="text" @click="deleteMethod(scope.row.id)" v-if="scope.row.id > 6">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>

            <el-card :body-style="{'overflow':'hidden','overflow-x':'auto'}">
                <div slot="header" class="clearfix">
                    <span>剧本视图</span>
                    <el-tooltip class="item" effect="dark" placement="top-start">
                        <div slot="content">
                            1. 粉色表示对话节点,可点击编辑。<br />
                            2. 蓝色表示选项节点,修改时,请点击上一个对话节点。<br />
                            3. 绿色表示结束节点,修改时,请点击上一个对话节点。<br />
                            4. 结束节点一般为固定跳出点。<br />
                        </div>
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </div>


                <vue2-org-tree :data="treeData" @on-node-click="NodeClick" :NodeClass="NodeClass" :judge="judge" />
            </el-card>

            <el-dialog title='编辑对话' :visible.sync="showNodeDialog" lock-scroll center>
                <el-form>
                    <el-form-item label="内容:" label-width="110px">
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                注意：特殊符号无法在正常文本展示<br />
                                (特殊符号：#-分段符)<br />
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-input v-model="nodeTempData.name" ref="nodeName" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="对话类型:" label-width="110px">
                        <el-select v-model="nodeTempData.speaker" placeholder="请选择">
                            <el-option v-for="item in speakerOptions" :key="item.id" :label="item.cn" :value="item.id">
                            </el-option>
                        </el-select>
                        <span>商人动作:</span>
                        <el-select v-model="nodeTempData.showType" placeholder="请选择" @change="getShowType">
                            <el-option v-for="item in traderOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="110px">
                        <el-button :type="isJumpDialog?'primary':'warning'"  @click="jumpDialog">{{isJumpDialog ? '切换为连接选项':'切换为连接对话'}}</el-button>
                    </el-form-item>

                    <el-form-item label="选项组:" label-width="110px" v-if="!isJumpDialog">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNodeItem()">添加选项
                        </el-button>
                        <div v-for="(row,index) in nodeItemsTemp" :key="index" style="display: flex;margin: 5px 0;">
                            选项{{index+1}}:
                            <el-input v-model="row.content" style="width: 33%;margin: 0 5px;"></el-input>
                            下一个对话:
                            <el-select v-model="row.nextNodeId" style="margin: 0 5px;">
                                <el-option v-for="item in nodes" :key="item.id" :label="item.dialogData.id + '-' + item.name.slice(0,20) + (item.name.length > 20?'...':'')"
                                    :value="item.dialogData.id">
                                </el-option>
                            </el-select>
                            <el-button type="primary" icon="el-icon-delete" @click="delNodeItem(index)"></el-button>
                        </div>
                    </el-form-item>

                    <el-form-item label="对话选项:" label-width="110px" v-if="isJumpDialog">
                        <el-select v-model="nodeTempData.nextNodeId" style="margin: 0 5px;" @change="getNextNodeId">
                            <el-option v-for="item in nodes" :key="item.id" :label="item.dialogData.id + '-' + item.name.slice(0,20) + (item.name.length > 20?'...':'')"
                                       :value="item.dialogData.id" v-if="item.dialogData.id>6">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="showNodeDialog = false">取 消</el-button>
                    <el-button type="primary" @click="editNodeData">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title='模拟剧本' :visible.sync="showSimulateNode" lock-scroll center>
                <template v-for="(item,itemIdx) in nodes" v-if="item.dialogData.id == nodeSimulateIndex">
                    <span :key="itemIdx" class="simulate-title">{{item.name}}</span>

                    <div class="simulate-entire" v-for="(item2,item2Idx) in item.dialogData.nodeItems" :key="item2Idx" v-if="item.dialogData.nodeItems > 0 || item.nextNodeId == '' || item.nextNodeId == undefined">
                        <el-button type="primary" @click="moreNodeShow(item2.nextNodeId)">
                            {{item2.content}}
                        </el-button>
                    </div>

                    <div class="simulate-entire" v-if="item.nextNodeId !== ''">
                        <el-button type="primary" @click="moreNodeShow(item.nextNodeId)" v-for="item3 in nodes" :key="item3.id" v-if="item3.id == item.nextNodeId">
                            {{item3.name}}
                        </el-button>
                    </div>
                </template>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="showSimulateNode = false">关闭模拟</el-button>
                    <el-button type="success" @click="nodeSimulateIndex = 0">重 置</el-button>
                    <el-button type="warning" @click="backDialog">上一句</el-button>
                </div>
            </el-dialog>

        </div>
    </el-card>

</template>

<script>
    import actionConfirm from '../../mixins/action_confirm'
    import paginationController from '../../mixins/pagination'
    import dialogApi from '../../service/dialog_api'
    import confApi from '../../service/conf_api'
    import {
        mapState
    } from 'vuex';
    import XLSX from 'xlsx';

    export default {
        name: "dramaEditor",
        data() {
            return {
                NodeClass: [
                    "myblue",
                    "mygre",
                    "mypink"
                ],
                treeData: {
                    id: '0',
                    label: '起始文本',
                    swtich: "mypink"
                },
                judge: {
                    swtich: true
                },
                showNodeDialog: false,
                showSimulateNode: false,
                showDetailTable: true,

                // 节点修改数据
                nodeTempData: {
                    name: '',
                    speaker: '请选择对话类型',
                    nodeItems: [],
                    optionType: 1,
                    nextNodeId: '',
                    showType: 0
                },

                // 商人动作选项
                traderOptions: [
                    {
                        label: '显示商人形象',
                        value: 0
                    },
                    {
                        label: '隐藏商人形象',
                        value: 1
                    }
                ],
                // 是否跳转对话
                isJumpDialog: true,

                dataIndex: 7,
                dataIdx: 7,

                nodeItemsTemp: [],
                speakerOptions: [],
                drama: '',
                templateId:0,
                nodes: [
                    {
                        id: '1',
                        name: '离开（神秘商人为奖励移动力，悬赏令活动为奖励配置表配置）',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 1,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '2',
                        name: '战斗',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 2,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '3',
                        name: '交易',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 3,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '4',
                        name: '奖励-狩猎点',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 4,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '5',
                        name: '奖励-怪兽碎片',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 5,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '6',
                        name: '奖励 - 商店随机送1',
                        speaker: 'NPC1',
                        dialogData: {
                            id: 6,
                            content: '',
                            speaker: 'NPC1',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                    {
                        id: '0',
                        name: '起始文本',
                        speaker: '请选择对话类型',
                        dialogData: {
                            id: 0,
                            content: '',
                            speaker: '请选择对话类型',
                            nodeItems: [],
                            optionType: 1,
                            nextNodeId: '',
                            showType: 0
                        }
                    },
                ],

                // 模拟对话索引
                nodeSimulateIndex: 0,

                // 返回上一句索引
                backDialogData: [0],

                // 最大语义化NUM
                maxLangNum:0,

                // 语义化表格
                langTableData:[],
                // 语义化表格当前页
                langTableCurrentPage:1,

                langData: [],
                // 固化id
                dramaId: '',

                randomEventLangBO: {
                    id: '',
                    langs: [],
                    dramaJson: '',
                    dramaName: ''
                },

                // 剧本配置表数据
                dramaConfigData: [],
                dramaConfigSelectVal: '',

                // 是否修改dramaId
                isModifyDramaId: false

            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.collectRandomEvent();
            this.getDramaData();
        },
        methods: {
            /**
             * 生成数据
             */
            generateData() {
                let dialogs = {};

                this.nodes.forEach(item => {
                    dialogs[item.dialogData.id] = item.dialogData;
                });
                this.drama = JSON.stringify(dialogs);
            },
            handleCurrentChange(val){
                this.langTableCurrentPage = val;
            },
            handleSizeChange(val) {
                this.langTableCurrentPage = 1;
                this.pageSize = val;
            },
            //TODO 固化功能
             //TODO 1。弹框，填数字
             //TODO 2. 请求 str之后的数据，返回语言包和修改后的字符串
             //TODO 3. 字符串替换
             //TODO 4.


            onCopy(e) {
                this.$message({
                    type: 'success',
                    message: '已复制至系统粘贴板'
                });
            },
            onError(e) {
                this.$message({
                    type: 'error',
                    message: '复制失败,请手动复制'
                });
            },

            /**
             * 固化
             */
            uploadRandomEventLang() {
                var drama = JSON.parse(this.drama);
                var data = [];
                var index = 1;
                for (var i in drama) {
                    if (drama[i].content.split("_")[0] !== 'randomEventDialogueGroupConfig') {
                        data.push({
                            id: ('randomEventDialogueGroupConfig_' + this.dramaId + '.' + index),
                            value: drama[i].content
                        })
                        drama[i].content = 'randomEventDialogueGroupConfig_' + this.dramaId + '.' + index;
                        index++;
                    }

                    drama[i].nodeItems.forEach(item => {
                        if (item.content.split("_")[0] !== 'randomEventDialogueGroupConfig') {
                            data.push({
                                id: ('randomEventDialogueGroupConfig_' + this.dramaId + '.' + index),
                                value: item.content
                            })
                            item.content = 'randomEventDialogueGroupConfig_' + this.dramaId + '.' + index;
                            index++;
                        }
                    })

                    if (drama[i].id == 0) {
                        this.randomEventLangBO.dramaName = this.$t(drama[i].speaker);
                    }
                }
                this.drama = JSON.stringify(drama);

                this.randomEventLangBO.id = this.dramaId;
                this.randomEventLangBO.langs = data;
                this.randomEventLangBO.dramaJson = this.drama;
                this.randomEventLangBO.templateId = this.templateId;

                dialogApi.randomEventLangUpload({
                    randomEventLangBO: this.randomEventLangBO,
                    token: this.token
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '固化成功'
                    })
                    this.collectRandomEvent();
                })
            },

            // 剧本语言包
            collectRandomEvent() {
                  dialogApi.randomEventLangs(
                      this.token
                  ).then(res => {
                      this.langData = res.dialogs;
                      this.speakerOptions = res.npcs;
                  })
            },

            /**
             * 解析数据
             * TODO 判断是否包含翻译
             */
            parseData() {
                if (!this.drama) return;

                var drama = JSON.parse(this.drama);
                var nodes = [];
                var maxIdx = 1;
                for (var i in drama) {
                    var name = '';
                    if (i == 1) {
                        name = '离开'
                    } else if (i == 2) {
                        name = '战斗'
                    } else if (i == 3) {
                        name = '交易'
                    } else if (i == 4) {
                        name = '奖励-狩猎点'
                    } else if (i == 5) {
                        name = '奖励-怪兽碎片'
                    } else if (i == 6) {
                        name = '奖励 - 商店随机送1'
                    }
                    if (drama[i].id >= maxIdx) {
                        maxIdx = drama[i].id;
                    }

                    nodes.push({
                        id: drama[i].id,
                        name: name ? name : drama[i].content,
                        speaker: drama[i].speaker,
                        dialogData: drama[i],
                        nextNodeId: drama[i].nextNodeId
                    })
                }

                let temp0 = nodes[0];
                nodes.splice(7, 0, temp0);

                this.nodes = nodes.slice(1);
                if (this.nodes.length > 7) {
                    this.nodes = this.nodes.slice(0, 7).concat(this.nodes.slice(7).reverse());
                }

                this.dataIdx = maxIdx + 1;
                this.dataIndex = maxIdx + 1;

                this.nodes.forEach(item7 => {
                    this.langData.forEach(item9 => {
                        if (item7.name == item9.id) {
                            item7.name = item9.value;
                        }

                        if (item7.dialogData.content == item9.id) {
                            item7.dialogData.content = item9.value;
                        }

                        item7.dialogData.nodeItems.forEach(item8 => {
                            if (item8.content == item9.id) {
                                item8.content = item9.value;
                            }
                        })
                    })
                })

                this.drama = JSON.stringify(drama);

                this.nodes.forEach((item2, index2) => {
                    if (item2.id == '0') {

                        var children = [];
                        if (item2.dialogData.nodeItems.length > 0 || (item2.dialogData.nodeItems.length == 0 && item2.dialogData.nextNodeId == '')) {
                            item2.dialogData.nodeItems.forEach((item3, index3) => {

                                children.push({
                                    id: item2.id + '-' + index3,
                                    // id: item3.nextNodeId,
                                    label: item3.content!==undefined?(item3.content.slice(0, 20) + (item3.content.length > 20 ? '...' : '')):'',
                                    children: this.findNodeItems(item3),
                                    swtich: 'myblue'
                                })
                            })
                            this.treeData = {
                                id: item2.id,
                                label: item2.name!==undefined?(item2.name.slice(0, 20) + (item2.name.length > 20 ? '...' : '')):'',
                                children: children,
                                swtich: 'mypink'
                            }

                        } else if (item2.dialogData.nextNodeId) {
                            this.nodes.forEach(item4 =>{
                                if (item4.id == item2.dialogData.nextNodeId) {
                                    this.treeData = {
                                        id: item2.dialogData.id,
                                        label: item2.name!==undefined?(item2.name.slice(0, 20) + (item2.name.length > 20 ? '...' : '')):'',
                                        swtich: 'mypink',
                                        children: this.findNodeItems({nextNodeId:item4.dialogData.id})
                                    }
                                }
                            })
                        }
                    }
                })
            },


            /**
             * @description: 获取map的长度
             * @param {Object} obj map对象
             * @return: map的长度
             */
            getLength(obj){
                var count = 0;
                for (var i in obj) {

                    if (obj.hasOwnProperty(i)) {
                        count++;

                    }
                }

                return count;
            },
            findNodeItems(item) {
                var _children = [];
                var __children = [];
                this.nodes.forEach(item2 => {
                    if (item.nextNodeId.toString() == item2.id) {
                        if (item2.dialogData.nodeItems.length > 0 ||(item2.dialogData.nodeItems.length == 0 && item2.dialogData.nextNodeId == '')) {
                            _children.push({
                                id: item.nextNodeId,
                                label: item2.name!==undefined?(item2.name.slice(0, 20) + (item2.name.length > 20 ? '...' : '')):'',
                                swtich: item2.dialogData.nodeItems.length > 0 ? 'mypink' : 'mygre',
                                children: __children
                            })

                            if (item2.dialogData.nodeItems.length > 0) {
                                item2.dialogData.nodeItems.forEach(item3 => {
                                    __children.push({
                                        id: item.nextNodeId,
                                        label: item3.content!==undefined?(item3.content.slice(0, 20) + (item3.content.length > 20 ? '...' : '')):'',
                                        children: this.findNodeItems(item3),
                                        swtich: 'myblue'
                                    })
                                })
                            } else if (item2.dialogData.nextNodeId)  {
                                this.nodes.forEach(item4 =>{
                                    if (item4.id == item2.dialogData.nextNodeId) {
                                        __children.push({
                                            id: item2.dialogData.nextNodeId,
                                            label: item4.name!==undefined?(item4.name.slice(0, 20) + (item4.name.length > 20 ? '...' : '')):'',
                                            swtich: item4.dialogData.nodeItems.length > 0 ? 'mypink' : 'mygre',
                                            children: this.findNodeItems({nextNodeId:item2.dialogData.id})
                                        })

                                        item4.dialogData.nodeItems.forEach(item5 => {
                                            __children.push({
                                                id: item2.dialogData.nextNodeId,
                                                label: item5.content!==undefined?(item5.content.slice(0, 20) + (item5.content.length > 20 ? '...' : '')):'',
                                                children: this.findNodeItems(item5),
                                                swtich: 'myblue'
                                            })
                                        })
                                    }
                                })
                            }
                        } else if (item2.dialogData.nextNodeId)  {
                            this.nodes.forEach(item4 =>{
                                if (item4.id == item2.dialogData.id) {
                                    _children.push({
                                        id: item2.dialogData.id,
                                        label: item4.name!==undefined?(item4.name.slice(0, 20) + (item4.name.length > 20 ? '...' : '')):'',
                                        swtich: item4.dialogData.nextNodeId ? 'mypink' : 'mygre',
                                        children: this.findNodeItems({nextNodeId:item4.dialogData.nextNodeId})
                                    })
                                }
                            })
                        }
                    }
                })

                return _children
            },

            // 树状图插件节点编辑
            NodeClick(e, data) {
                console.log(data)

                if (data.swtich == 'mypink') {
                    // 打开节点编辑框
                    this.showNodeDialog = true;

                    var _data = this.nodes;
                    _data.forEach(item => {
                        if (item.id == data.id) {
                            this.nodeTempData = item;
                            this.nodeItemsTemp = item.dialogData.nodeItems;
                            this.nodeTempData.showType = item.dialogData.showType;
                            this.nodeTempData.nextNodeId = item.dialogData.nextNodeId;
                        }

                        if (this.nodeItemsTemp.length > 0) {
                            this.isJumpDialog = false;
                        } else {
                            this.isJumpDialog = true;
                        }
                    })
                }

            },

            // 添加对话选项
            addNodeItem() {
                this.nodeItemsTemp.push({
                    content: "",
                    nextNodeId: 1
                })
            },

            // 删除对话选项
            delNodeItem(index) {
                this.nodeItemsTemp.splice(index, 1)
            },

            // 新建对话
            onAddDialog() {
                let newNode = {}
                newNode.id = this.dataIdx++
                newNode.name = '对话' + newNode.id
                // newNode.speaker = 'NPC1'

                this.nodes.forEach(item => {
                    if (item.id == '0') {
                        newNode.speaker = item.speaker;
                    }
                })

                // 对话框数据
                let dialogData = {}
                dialogData.id = this.dataIndex++
                dialogData.content = newNode.name
                dialogData.speaker = newNode.speaker
                dialogData.nodeItems = []
                dialogData.optionType = 1
                dialogData.nextNodeId = ''
                dialogData.showType = 0
                newNode.dialogData = dialogData

                this.nodes.splice(7, 0, newNode);
                this.updateMethod(newNode);
                this.addNodeItem();
            },

            // 修改按钮触发
            updateMethod(data) {
                if (data.dialogData.id == 0 || data.dialogData.id > 6) {
                    // 打开节点编辑框
                    this.showNodeDialog = true;
                    console.log(data)
                    this.nodeTempData = data;
                    this.nodeTempData.showType = data.dialogData.showType;
                    this.nodeTempData.nextNodeId = data.dialogData.nextNodeId;
                    this.nodeItemsTemp = data.dialogData.nodeItems;
                    // if (this.nodeItemsTemp.length > 0) {
                    if (this.nodeTempData.nextNodeId == '' || this.nodeItemsTemp.length > 0) {
                        this.isJumpDialog = false;
                    } else {
                        this.isJumpDialog = true;
                    }
                }
            },
            // 删除按钮触发
            deleteMethod(id) {
                this.$confirm('此操作将删除该节点, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.nodes.forEach((item, index) => {
                        if (item.id == id) {
                            this.nodes.splice(index, 1)
                            this.editNodeData();
                        }
                    })
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            // 修改节点数据
            editNodeData() {
                this.nodes.forEach(item => {
                    if (item.id == this.nodeTempData.id) {
                        item.name = this.nodeTempData.name
                        item.dialogData.content = this.nodeTempData.name
                        item.dialogData.speaker = this.nodeTempData.speaker
                        item.dialogData.nodeItems = this.nodeItemsTemp
                        item.dialogData.optionType = this.nodeTempData.optionType
                        item.dialogData.nextNodeId = this.nodeTempData.nextNodeId
                        item.dialogData.showType = this.nodeTempData.showType

                        if (this.nodeItemsTemp.length > 0) {
                            this.isJumpDialog = false;
                        } else {
                            this.isJumpDialog = true;
                        }

                        if (this.nodeTempData.optionType == 1) {

                            this.nodeTempData.nextNodeId = '';

                        } else if (this.nodeTempData.optionType == 2) {

                            // 切换类型，清理数据
                            this.nodeItemsTemp = [];
                            this.nodeTempData.dialogData.nodeItems = [];
                        }

                    }
                })

                this.nodes.forEach((item2, index2) => {
                    if (item2.id == '0') {

                        var children = [];
                        if (item2.dialogData.nodeItems.length > 0 || (item2.dialogData.nodeItems.length == 0 && item2.dialogData.nextNodeId == '')) {
                            item2.dialogData.nodeItems.forEach((item3, index3) => {

                                children.push({
                                    id: item2.id + '-' + index3,
                                    // id: item3.nextNodeId,
                                    label: item3.content!==undefined?(item3.content.slice(0, 20) + (item3.content.length > 20 ? '...' : '')):'',
                                    children: this.findNodeItems(item3),
                                    swtich: 'myblue'
                                })
                            })

                            this.treeData = {
                                id: item2.id,
                                label: item2.name!==undefined?(item2.name.slice(0, 20) + (item2.name.length > 20 ? '...' : '')):'',
                                children: children,
                                swtich: 'mypink'
                            }
                        }
                        else if (item2.dialogData.nextNodeId) {
                            this.nodes.forEach(item4 =>{
                                if (item4.id == item2.dialogData.nextNodeId) {
                                    this.treeData = {
                                        id: item2.dialogData.id,
                                        label: item2.name!==undefined?(item2.name.slice(0, 20) + (item2.name.length > 20 ? '...' : '')):'',
                                        swtich: 'mypink',
                                        children: this.findNodeItems({nextNodeId:item4.dialogData.id})
                                    }
                                }
                            })
                        }
                    }
                })
                console.log(this.treeData)

                this.showNodeDialog = false;
            },

            // 展示对话模拟
            simulateNodeShow(data) {
                this.showSimulateNode = true;
                this.nodeSimulateIndex = 0;
                if (data.length > 0) {
                    this.nodes = JSON.parse(data).nodes;
                }
                console.log(this.nodes)
            },

            // 展示对话模拟详情
            moreNodeShow(id) {
                this.nodeSimulateIndex = id;

                this.backDialogData.push(id)
            },

            backDialog() {
                if (this.nodeSimulateIndex !== 0) {
                    this.backDialogData.splice(-1)
                    this.nodeSimulateIndex = this.backDialogData[this.backDialogData.length - 1]
                }
            },

            getDramaData() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'random_event_dialogue_group_config'
                }).then(res => {
                    this.dramaConfigData = res;
                })
            },

            getDramaConfigSelectVal(e) {
                console.log(e)
                var dramaId = e.split('-')[0];
                var templateId = e.split('-')[1];
                var drama = e.split('-')[2];
                this.dramaId = dramaId;
                this.templateId = templateId;
                this.drama = drama;
                if (e !== '') {
                    this.isModifyDramaId = true;
                } else {
                    this.isModifyDramaId = false;
                }
                this.isModifyDramaId = true;
            },

            // 跳转对话
            jumpDialog() {
                this.nodeItemsTemp = [];
                this.nodeTempData.nextNodeId = ''
                this.isJumpDialog = !this.isJumpDialog;
            },

            getNextNodeId(e) {
                this.$forceUpdate();
            },
            getShowType(e) {
                this.$forceUpdate();
            }
        }
    }
</script>

<style lang="less">
    .myblue {
        background-color: skyblue;
        color: #ffffff;
    }

    .mygre {
        background-color: green;
        color: #ffffff;
    }

    .mypink {
        background-color: pink;
        color: #ffffff;
    }

    .simulate-title {
        font-weight: bold;
    }

    .simulate-btn {
        margin: 10px 0;
    }
    .simulate-entire {
        margin: 10px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/lang_dialog/drama_editor.vue